import './style.scss';
import HeaderSearch from './js/components/header-search';
import Carousel from './js/components/carousel';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

jQuery(function ($) {

  /*************************
   HEADER SEARCH
  **************************/
  const headerSearch = new HeaderSearch($);
  headerSearch.init();

  /*************************
   CAROUSEL
  **************************/
  const carousel = new Carousel($);
  carousel.init();

  /*************************
   SCROLL DOWN ARROW (from scroll.js)
  **************************/
  $('.scroll-down-arrow').on('click touchstart', function () {
    $('html, body').animate({
      scrollTop: $('div.stats-panel').offset().top
    }, 800);
  });

  /*************************
   SCROLL TO TOP (from scroll.js)
  **************************/
  const $scrollTop = $('#scroll-to-top');

  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 150) {
      $scrollTop.addClass('displayed');
    } else {
      $scrollTop.removeClass('displayed');
    }
  });

  $scrollTop.on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 500);
  });

  /*************************
   MASONRY
  **************************/
  const $grid = $('.grid');

  if ($grid.length) {

    const gridMasonry = new Masonry('.grid', {
      itemSelector: '.grid-item',
      percentPosition: true
    });

    imagesLoaded($grid[0], function () {
      gridMasonry.layout();
    });
  }

  /*************************
   DONATE TOGGLE
  **************************/
  $('.donate-main label').on('click', function () {
    $(this)
      .parent('li')
      .parent('ul')
      .children()
      .removeClass('donate-active');

    $(this)
      .parent('li')
      .addClass('donate-active');
  });

  /*************************
   TEXT ROTATOR (from scroll.js)
  **************************/
  function TxtRotate(el, toRotate, period) {
    this.toRotate = toRotate;
    this.el = el;
    this.loopNum = 0;
    this.period = parseInt(period, 10) || 2000;
    this.txt = '';
    this.isDeleting = false;
    this.tick();
  }

  TxtRotate.prototype.tick = function () {
    const i = this.loopNum % this.toRotate.length;
    const fullTxt = this.toRotate[i];

    if (this.isDeleting) {
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    this.el.innerHTML = `<span class="wrap">${this.txt}</span>`;

    let delta = 300 - Math.random() * 100;

    if (this.isDeleting) delta /= 25;

    if (!this.isDeleting && this.txt === fullTxt) {
      delta = this.period;
      this.isDeleting = true;
    } else if (this.isDeleting && this.txt === '') {
      this.isDeleting = false;
      this.loopNum++;
      delta = 500;
    }

    setTimeout(() => this.tick(), delta);
  };

  const elements = document.getElementsByClassName('txt-rotate');

  for (let i = 0; i < elements.length; i++) {
    const toRotate = elements[i].getAttribute('data-rotate');
    const period = elements[i].getAttribute('data-period');

    if (toRotate) {
      new TxtRotate(elements[i], JSON.parse(toRotate), period);
    }
  }

  /*************************
   TEXT ROTATOR CSS INJECTION
  **************************/
  const css = document.createElement('style');
  css.innerHTML = `.txt-rotate > .wrap { border-right: 0.08em solid #666 }`;
  document.head.appendChild(css);

});


// WEBPACK FOOTER //
// ./src/index.js